import { render, staticRenderFns } from "./UserProfileEdit.vue?vue&type=template&id=603d06f2&"
import script from "./UserProfileEdit.vue?vue&type=script&lang=js&"
export * from "./UserProfileEdit.vue?vue&type=script&lang=js&"
import style0 from "./UserProfileEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports